import React from "react"

import { Button } from "@coval/ui"
import { CopyIcon } from "@radix-ui/react-icons"

interface CopyTranscriptButtonProps {
  onCopy: () => void
  className?: string
}

export const CopyTranscriptButton: React.FC<CopyTranscriptButtonProps> = ({
  onCopy,
  className = "",
}) => {
  return (
    <Button
      icon
      tooltip="Copy transcript"
      variant="ghost"
      onClick={onCopy}
      className={`opacity-70 hover:opacity-100 ${className}`}
    >
      <CopyIcon className="w-4 h-4" />
    </Button>
  )
}
